import { AfterViewInit, Component, ElementRef, EventEmitter, forwardRef, Input, OnChanges, Output, Renderer2, AfterViewChecked, ViewChild, Inject } from '@angular/core';
import { ControlValueAccessor, UntypedFormControl, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'gs-textarea-clipboard',
  templateUrl: './gs-textarea-clipboard.component.html',
  styleUrls: ['./gs-textarea-clipboard.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => GsTextAreaClipboardComponent),
      multi: true
    }
  ]
})
export class GsTextAreaClipboardComponent implements ControlValueAccessor, AfterViewInit, OnChanges, AfterViewChecked {
  @Input() label: string;
  @Input() labelSmall: string;
  @Input() name: string;
  @Input() placeholder: string;
  @Input() formControl: UntypedFormControl;
  @Input() cssClass: string;
  @Input() hideErrorMessage: boolean = false;
  @Input() rows: number = 4;
  @Input() autoFocus: boolean;
  @Input() tabindex: number;
  @Input() customId: number;

  @Output() blur: EventEmitter<string> = new EventEmitter<string>();

  @ViewChild('textareaControl')
  textareaControl: ElementRef;

  // Private variables
  private inputValue: string;
  private isVisible: boolean = false;

  // Public variables
  public fnOnChange: any = () => { };
  public fnOnTouch: any = () => { };
  public isCopied: boolean = false;

  constructor(private el: ElementRef, private renderer: Renderer2) {

  }

  ngAfterViewInit(): void {

  }

  ngOnChanges() {

  }

  ngAfterViewChecked() {
    if (this.isVisible == false && this.textareaControl.nativeElement.offsetParent != null) {
      // isVisible switched from false to true
      this.isVisible = true;
      if (this.autoFocus) {
        this.textareaControl.nativeElement.focus();
      }
    }
    else if (this.isVisible == true && this.textareaControl.nativeElement.offsetParent == null) {
      // isVisible switched from true to false
      this.isVisible = false;
    }
  }

  private triggerChange($event) {
    this.fnOnChange($event);
    const event = new CustomEvent('change', { bubbles: true });
    this.el.nativeElement.dispatchEvent(event);
  }

  // Public methods

  public set value(val: string) {
    if (val !== undefined) {
      this.inputValue = val;
    }
  }

  public get value() {
    return this.inputValue;
  }

  public writeValue(val: string): void {
    this.value = val;
  }

  public writePlaceholder(val: string): void {
    this.placeholder = val;
  }

  public registerOnChange(fn: any): void {
    this.fnOnChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.fnOnTouch = fn;
  }

  public onChange() {
    this.triggerChange(this.inputValue);
  }

  public copy() {
    if (this.formControl.disabled) {
      this.copyForDisabledField();
      return;
    }
    this.textareaControl.nativeElement.select();
    window.document.execCommand("copy");
    this.isCopied = true;
    setTimeout(() => {
      this.isCopied = false;
    }, 3000);
  }

  copyForDisabledField() {
    this.formControl.enable();
    setTimeout(() => {
      this.textareaControl.nativeElement.select();
      this.formControl.disable();
      window.document.execCommand("copy");
      this.isCopied = true;
    }, 100);
    setTimeout(() => {
      this.isCopied = false;
    }, 3000);
  }
}
